/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from "../../utils/axiosInstance"
// ----------------------------------------------------------------------

const url = process.env.BACKEND_URL;
const RSL_BACKEND_URL = process.env.RSL_BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  rentalBusListNew: [],
  rentalBusListDetail: undefined,
  bookingRes: undefined,
  bookingCarRes: undefined,
  busCategoryRes: [],
  walletDetails: [],
  walletRecharge: [],
  walletRechargeCheck: undefined,
};

const slice = createSlice({
  name: 'cards',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getRentalBusListNewSuccess(state, action) {
      state.isLoading = false;
      state.rentalBusListNew = action.payload;
    },
    addCardDetailsSuccess(state, action) {
      state.isLoading = false;
      state.addCardDetailsNew = action.payload;
    },
    listCardDetailsSuccess(state, action) {
      state.isLoading = false;
      state.listCardDetailsNew = action.payload;
    },
    walletDetailsSuccess(state, action) {
      state.isLoading = false;
      state.walletDetails = action.payload;
    },
    walletRechargeSuccess(state, action) {
      state.isLoading = false;
      state.walletRecharge = action.payload;
    },
    walletRechargeCheckSuccess(state, action) {
      state.isLoading = false;
      state.walletRechargeCheck = action.payload;
    },
    deleteCardDetailsSuccess(state, action) {
      state.isLoading = false;
      state.deleteCardDetailsNew = action.payload;
    },
    checkAuthDetailsSuccess(state, action) {
      state.isLoading = false;
      state.checkAuthDetailsNew = action.payload;
    },
    // Get CarList
    getRentalBusDetailsNewSuccess(state, action) {
      state.isLoading = false;
      state.rentalBusListDetail = action.payload;
    },
    // Get CarList
    getRentalBusBookingNewSuccess(state, action) {
      state.isLoading = false;
      state.bookingRes = action.payload;
    },
    getRentalCarBookingNewSuccess(state, action) {
      state.isLoading = false;
      state.bookingCarRes = action.payload;
    },
    getSearchBusSuccess(state, action) {
      state.isLoading = false;
      state.busSearchRes = action.payload;
    },
    getBusCategorySuccess(state, action) {
      state.isLoading = false;
      state.busCategoryRes = action.payload;
    },
    getSearchBusFilterSuccess(state, action) {
      state.isLoading = false;
      state.busSearchFilterRes = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export function getRentalBusListNew(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/bus/listBusPackages`,
        filterParam
      );

      dispatch(
        slice.actions.getRentalBusListNewSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addCardDetails(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/taxi/createPreAuthorization`, filterParam);
      dispatch(
        slice.actions.addCardDetailsSuccess(
          response.data
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function listCardDetails(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      //   const response = await axiosInstance.post(`${RSL_BACKEND_URL}/taxi/checkAuthStatus`, filterParam);
      const response = await axiosInstance.post(`${RSL_BACKEND_URL}/passenger/getCreditCardDetails`, filterParam);
      dispatch(
        slice.actions.listCardDetailsSuccess(
          response.data
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function deleteCardDetails(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      //   const response = await axiosInstance.post(`${RSL_BACKEND_URL}/taxi/checkAuthStatus`, filterParam);
      const response = await axiosInstance.post(`${RSL_BACKEND_URL}/passenger/creditCardDelete`, filterParam);
      dispatch(
        slice.actions.deleteCardDetailsSuccess(
          response.data
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function checkAuthDetails(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/taxi/checkAuthStatus`, filterParam);
      dispatch(
        slice.actions.checkAuthDetailsSuccess(
          response.data
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getWalletDetails(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      //   const response = await axiosInstance.post(`${url}/taxi/checkAuthStatus`, filterParam);
      const response = await axiosInstance.post(`${RSL_BACKEND_URL}/passenger/passengerWallet`, filterParam);
      dispatch(
        slice.actions.walletDetailsSuccess(
          response.data
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getWalletRecharge(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      //   const response = await axiosInstance.post(`${url}/taxi/checkAuthStatus`, filterParam);
      const response = await axiosInstance.post(`${url}/taxi/getRslWalletTelrUrl`, filterParam);
      dispatch(
        slice.actions.walletRechargeSuccess(
          response.data
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getWalletRechargeCheck(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      //   const response = await axiosInstance.post(`${url}/taxi/checkAuthStatus`, filterParam);
      const response = await axiosInstance.post(`${url}/taxi/addRslWalletAmount?`, filterParam);
      dispatch(
        slice.actions.walletRechargeCheckSuccess(
          response.data
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}




export function getRentalBusBooking(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/booking/busBooking`,
        filterParam
      );

      dispatch(slice.actions.getRentalBusBookingNewSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getRentalCarBooking(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/booking/carBooking`,
        filterParam
      );

      dispatch(slice.actions.getRentalCarBookingNewSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchBus(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/bus/searchBus`,
        obj
      );
      dispatch(slice.actions.getSearchBusSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function busCategory(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/bus/getBusTypes`,
        obj
      );
      dispatch(slice.actions.getBusCategorySuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchBusFilter(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/bus/filterList`,
        obj
      );
      dispatch(
        slice.actions.getSearchBusFilterSuccess(response.data?.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
